var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconDuplicate = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M15.429 0H2.857a.571.571 0 00-.571.571v1.715H.57a.571.571 0 00-.57.571V15.43a.57.57 0 00.571.571h12.572a.571.571 0 00.571-.571v-1.715h1.715a.571.571 0 00.571-.571V.57a.571.571 0 00-.571-.57zM12.57 14.857H1.143V3.43H12.57v11.428zm2.286-2.286h-1.143V2.857a.571.571 0 00-.571-.571H3.429V1.143h11.428V12.57z",
  fill: "#787878"
})));

export default SvgIconDuplicate;